/** В файле содержится браузерная часть функционала определения контекста
 * приложения.
 *
 * После получения любого ответа от сервера удаляется куки с названием
 * контекста, чтобы не мешать работать другим вкладкам браузера
 *
 * Перед отправкой на сервер ко всем зарпосам (Аксиоса и просто из браузера)
 * дописывается кукис с названием контекста
 *
 * В переиод между запросами контекст содержится в виде глобальной переменной и
 * доступен только одной вкладке браузера
 */

;
/*
 * Удаляем кукис при обычной загрузке страницы
 */
window.addEventListener('load', function () {
    // Очень помогает при отладке
    AppUtils.showServiceMessage(appContext);
    // Удаляем кукис при обычной загрузке
    AppUtils.deleteCookie(appContextParameterName);
});

/*
 * Удаляем кукис при запросах из Аксиоса
 */
axios.interceptors.response.use(function (response) {
    // Удаляем кукис
    AppUtils.deleteCookie(appContextParameterName);
    return response;
}, function (error) {
    // Какая бы ошибка не была, в любом случае пробуем удалить кукис
    AppUtils.deleteCookie(appContextParameterName);
    AppUtils.showServiceError(error);
    return Promise.reject(error);
});

// Дописываем кукис при обычных запросах браузера
window.addEventListener('beforeunload', function () {
    AppUtils.setCookie(appContextParameterName, appContext, 60);
});

// Дописываем кукис при запросах Аксиоса.
axios.interceptors.request.use(function (config) {
    AppUtils.setCookie(appContextParameterName, appContext, 60);
    return config;
}, function (error) {
    AppUtils.showServiceError(error);
    return Promise.reject(error);
});
